<template>


    <el-main class="app_border">
        <el-row>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="12">
                <div class="grid-content bg-purple">
                    <el-input v-model="form.title" placeholder="请输入关键词"></el-input>
                </div>
            </el-col>
            <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="8">
                <div class="grid-content bg-purple-light btn_search">
                    <el-button @click="search" type="primary">检索</el-button>
                </div>
            </el-col>
            <el-col   :md="14" :lg="14"  class="hidden-sm-and-down">
                <div class="grid-content bg-purple-light adbox">
                    <img src="../assets/adbox.png">
                </div>
            </el-col>
        </el-row>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
        @select="handleSelect">
        <el-menu-item index="1">最新</el-menu-item>
        <el-menu-item index="2">热门</el-menu-item>
        <el-menu-item index="3">好评</el-menu-item>
        </el-menu>
        <div class="line"></div>
        <!--产品列表-->
        <el-main class="app_productlist">
            <el-row>
                <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="24">

                    <div class="grid-content bg-purple" :class="getmainclass" >
                        <el-row class="app_item" v-for="(item,index) in items" :key="item.id" >
                            <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="24">
                                <div :class="getimgclass">
                                    <img @click="gotoshop(item)" v-lazy="item.app_src"/>
                                </div>

                            </el-col>
                            <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="24" class="app_infolist">
                                <p  @click="gotoshop(item)">
                                应用名称：{{item.app_name}}
                                </p>



                                <p>
                                    价格：{{item.sp_price}}元
                                </p>

                                <p>
                                    评分：
                                    <el-rate
                                            class="ratebar"
                                            v-model="item.app_rate"
                                            disabled
                                            show-score
                                            text-color="#ff9900"
                                            score-template="{value}">
                                    </el-rate>
                                </p>
                                <el-button  @click="gotoshop(item)" size="mini" type="danger" icon="el-icon-goods">购买</el-button>
                                <span v-show="item.sp_downs>0" class="downnums">[安装{{item.sp_downs}}次]</span>
                            </el-col>
                        </el-row>
                        <div v-show="flagopen" class="resultmsg">
                            <el-alert
                                    :closable="false"
                                    title="没有找到相关应用"
                                    type="warning">
                            </el-alert>
                        </div>
                    </div>
                    <div v-show="pages!=1" class="app_loadmore" v-loading="loading" @click="getdata">{{loadingtext}}</div>
                </el-col>
                <el-col :md="6" :lg="6" class="hidden-sm-and-down">
                    <div class="grid-content bg-purple">
                        <div class="adimg">
                            <img src="../assets/ad.png" />
                        </div>
                        <p v-for="item in articles">
                            {{item.title}}
                        </p>
                    </div>
                </el-col>
            </el-row>
        </el-main>


    </el-main>

</template>
<script>
    import axios from 'axios'
    export default
    {
        name: 'Extend',
                data()
        {

            return {
                currenttype:'',
                flagopen:false,
                hasmounted:false,
                pages:0,
                loadingtext:'点击加载更多',
                loading: false,
                activeIndex: "1",
                articles:[],
                items: [],
                form:{
                    title:'',
                    order:1,
                    page:0
                }


            }
        },
        computed:{

            getimgclass:function(){
                var userAgentInfo = navigator.userAgent;

                var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
                var _class='_imgthumb'
                for (var v = 0; v < Agents.length; v++) {
                    if (userAgentInfo.indexOf(Agents[v]) > 0) {
                        _class='xs-_imgthumb'
                        break;
                    }


                }
                return _class
            },
            getmainclass:function(){
                var userAgentInfo = navigator.userAgent;

                var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
                var _class='app_items'
                for (var v = 0; v < Agents.length; v++) {
                    if (userAgentInfo.indexOf(Agents[v]) > 0) {
                        _class='xs_app_items'
                        break;
                    }


                }
                return _class
            }
        }
    ,
        methods: {
            gotoshop(item){
                this.$router.push({name: 'ShopInfo',params: {id:item.Id},query: {id:item.Id}})
            },
            search(){
                this.items=[]
                this.form.page=0
                this.getdata()
            },
            handleSelect(key)
            {
                this.form.page=0
                this.form.order=key
                this.items=[]
                this.getdata()
            },
            pagescroller: function(){
                console.log("ok")
            },
            getdata: function () {
                this.loading = true
                this.loadingtext = '加载中...'
                var _this = this;
                // 设置一个开关来避免重负请求数据
                var sw = true;


                if (_this.form.page <= _this.pages) {
                    var params = 'ajax=' + encodeURIComponent(JSON.stringify(_this.form));
                    axios.post(this.$store.state.baseurl + 'appstore/getlist', params).then(function (response) {
                        if(response.data.data.length==0){
                            _this.items=[]
                            _this.loading = false
                            _this.flagopen=true
                            _this.loadingtext = ''
                            return false
                        }
                        _this.flagopen=false

                        response.data.data.forEach(function (val, index) {
                            _this.items.push(val);
                            _this.pages =val.pagenums
                            //   console.log(val);
                        })

                        _this.loading = false
                        if (_this.form.page == _this.pages){
                            _this.loadingtext = '我也是有底线的'
                        }else{
                            _this.loadingtext = '点击加载更多'
                        }

                        _this.form.page++
                        // _this.articles = response.data

                    }).catch(function (error) {
                        console.log(error);
                    });
                }else{

                    _this.loading = false
                    _this.loadingtext = '我也是有底线的'
                }
            }


        }
    ,mounted(){
        var _this = this;
        _this.items=[]
        var typename=this.$route.query.type

        switch(typename){
            case 'plugin':
                _this.form.type='plugin'
                break;
            case 'template':
                _this.form.type='template'
                break;
            case 'extend':
                _this.form.type='extend'
                break;
            default:
                _this.form.type='all'
                break;
        }


        var params = 'ajax='+encodeURIComponent(JSON.stringify(_this.form));
        axios.post(this.$store.state.baseurl+'appstore/getlist',params).then(function (response) {

            _this.pages = response.data.pagenums

            response.data.data.forEach(function(val,index){
                _this.items.push(val);
                _this.pages =val.pagenums
                //   console.log(val);
            })
            _this.form.page=2
            _this.loading = false
            _this.loadingtext = '点击加载更多'
            // _this.articles = response.data

        }).catch(function (error) {
            console.log(error);
        });
        this.hasmounted=true



    }
    }
</script>


// WEBPACK FOOTER //
// src/components/Extend.vue